import { render, staticRenderFns } from "./overview-notifications.vue?vue&type=template&id=7be14bd8&scoped=true"
import script from "./overview-notifications.vue?vue&type=script&lang=js"
export * from "./overview-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be14bd8",
  null
  
)

export default component.exports